var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4 alert alert-info"},[_c('h3',[_vm._v("404 - Page Not Found")]),_vm._v(" "),_c('p',[_vm._v("Sorry, you tried to access a page that does not exist.")])])
}]

export { render, staticRenderFns }